import { useEffect } from "react";

// Watches every [data-reveal] element on the page and adds `is-in` the first
// time it scrolls into view. Variants and stagger live in reveal.css.
export function useReveal(deps = []) {
	useEffect(() => {
		const root = document.documentElement;
		if (!("IntersectionObserver" in window)) return undefined;
		root.classList.add("js-reveal");

		// A fully clipped element never reports as intersecting, so clip-path
		// variants are triggered by their parent's visibility instead.
		const watchers = new Map();
		const io = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					(watchers.get(entry.target) || []).forEach((el) => el.classList.add("is-in"));
					io.unobserve(entry.target);
				});
			},
			{ rootMargin: "0px 0px -12% 0px", threshold: 0 }
		);

		document.querySelectorAll("[data-reveal]:not(.is-in)").forEach((el) => {
			const clipped = el.dataset.reveal !== "rise";
			const target = clipped && el.parentElement ? el.parentElement : el;
			if (!watchers.has(target)) watchers.set(target, []);
			watchers.get(target).push(el);
			io.observe(target);
		});
		return () => io.disconnect();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, deps);
}
